<div class="w-full max-w-md pt-10 mx-auto">
  <a routerLink="/"
    class="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" class="size-5">
      <path d="M12.7083 5L7.5 10.2083L12.7083 15.4167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round"></path>
    </svg>
    Volver al inicio
  </a>
</div>

<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
  <div>
    <div class="mb-5 sm:mb-8">
      <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
        {{ showBusinessSelection ? 'Selecciona tu empresa' : 'Iniciar Sesión - CRM' }}
      </h1>
      @if (showBusinessSelection) {
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Tu cuenta pertenece a varias empresas. Elige con cuál quieres ingresar.
        </p>
      }
    </div>

    <!-- Paso 2: selección de empresa (CASO B) -->
    @if (showBusinessSelection) {
      @if (errorMessage) {
        <div class="mb-5">
          <app-alert [variant]="'error'" [message]="errorMessage"></app-alert>
        </div>
      }
      <ul class="flex flex-col gap-3">
        @for (option of businessOptions; track option.businessId) {
          <li>
            <button
              type="button"
              (click)="selectBusiness(option)"
              [disabled]="isLoading"
              class="flex items-center justify-between w-full gap-3 px-4 py-3 text-left transition bg-white border border-gray-300 rounded-lg hover:border-brand-500 hover:bg-brand-50 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-transparent dark:border-gray-700 dark:hover:bg-white/[0.03]">
              <span class="flex flex-col">
                <span class="font-medium text-gray-800 dark:text-white/90">{{ option.businessName }}</span>
                <span class="text-theme-xs text-gray-500 dark:text-gray-400">{{ option.roleName }}</span>
              </span>
              <svg class="text-gray-400 shrink-0" width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 4.16667L13.3333 10L7.5 15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </li>
        }
      </ul>
      <button
        type="button"
        (click)="backToCredentials()"
        [disabled]="isLoading"
        class="mt-5 text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 disabled:opacity-50">
        Volver
      </button>
    } @else {

    <div class="grid grid-cols-1 gap-3 mb-5">
      <button
        type="button"
        (click)="onGoogleSignIn()"
        [disabled]="isGoogleLoading || isMicrosoftLoading || isLoading"
        class="inline-flex items-center justify-center w-full gap-3 px-4 py-3 text-sm font-medium text-gray-700 transition bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-transparent dark:text-white/90 dark:border-gray-700 dark:hover:bg-white/[0.03]">
        @if (isGoogleLoading) {
          <span class="flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            Redirigiendo con Google...
          </span>
        } @else {
          <span class="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.207 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.27 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
              <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.27 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
              <path fill="#4CAF50" d="M24 44c5.17 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.157 35.091 26.679 36 24 36c-5.186 0-9.625-3.329-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
              <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.05 12.05 0 0 1-4.084 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
            </svg>
            Continuar con Google
          </span>
        }
      </button>

      <button
        type="button"
        (click)="onMicrosoftSignIn()"
        [disabled]="isMicrosoftLoading || isGoogleLoading || isLoading"
        class="inline-flex items-center justify-center w-full gap-3 px-4 py-3 text-sm font-medium text-gray-700 transition bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-transparent dark:text-white/90 dark:border-gray-700 dark:hover:bg-white/[0.03]">
        @if (isMicrosoftLoading) {
          <span class="flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            Redirigiendo con Microsoft...
          </span>
        } @else {
          <span class="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="8" height="8" fill="#F25022"/>
              <rect x="11" y="1" width="8" height="8" fill="#7FBA00"/>
              <rect x="1" y="11" width="8" height="8" fill="#00A4EF"/>
              <rect x="11" y="11" width="8" height="8" fill="#FFB900"/>
            </svg>
            Continuar con Microsoft
          </span>
        }
      </button>
    </div>

    <!-- Divider -->
    <div class="relative py-3 sm:py-5">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-200 dark:border-gray-800"></div>
      </div>
    </div>

    <!-- INC 17.5: motivo del cierre de sesión (inactividad / expiración / otra pestaña) -->
    @if (sessionNotice) {
      <div class="mb-6">
        <app-alert
          [variant]="'warning'"
          [title]="'Sesión finalizada'"
          [message]="sessionNotice">
        </app-alert>
      </div>
    }

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="mb-6">
        <app-alert
          [variant]="'error'"
          [message]="errorMessage">
        </app-alert>
      </div>
    }

    <!-- Form -->
    <form (ngSubmit)="onSignIn()" class="space-y-6">
      <div>
        <app-label>Correo Electrónico <span class="text-error-500">*</span></app-label>
        <app-input-field
          type="email"
          placeholder="correo@ejemplo.com"
          [(value)]="email"
          name="email"
          class="form-input"
          (valueChange)="onEmailChange()"
          required />
      </div>

      <div>
        <app-label>Contraseña <span class="text-error-500">*</span></app-label>
        <div class="relative">
          <app-input-field
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Ingresa tu contraseña"
            [(value)]="password"
            name="password"
            class="form-input"
            (valueChange)="onPasswordChange()"
            required />
          <span
            (click)="togglePasswordVisibility()"
            class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2">
            @if (showPassword) {
              <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="fill-gray-500 dark:fill-gray-400 size-5">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.0002 13.8619C7.23361 13.8619 4.86803 12.1372 3.92328 9.70241C4.86804 7.26761 7.23361 5.54297 10.0002 5.54297C12.7667 5.54297 15.1323 7.26762 16.0771 9.70243C15.1323 12.1372 12.7667 13.8619 10.0002 13.8619ZM10.0002 4.04297C6.48191 4.04297 3.49489 6.30917 2.4155 9.4593C2.3615 9.61687 2.3615 9.78794 2.41549 9.94552C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C13.5184 15.3619 16.5055 13.0957 17.5849 9.94555C17.6389 9.78797 17.6389 9.6169 17.5849 9.45932C16.5055 6.30919 13.5184 4.04297 10.0002 4.04297ZM9.99151 7.84413C8.96527 7.84413 8.13333 8.67606 8.13333 9.70231C8.13333 10.7286 8.96527 11.5605 9.99151 11.5605H10.0064C11.0326 11.5605 11.8646 10.7286 11.8646 9.70231C11.8646 8.67606 11.0326 7.84413 10.0064 7.84413H9.99151Z">
                </path>
              </svg>
            } @else {
              <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="fill-gray-500 dark:fill-gray-400 size-5">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.63803 3.57709C4.34513 3.2842 3.87026 3.2842 3.57737 3.57709C3.28447 3.86999 3.28447 4.34486 3.57737 4.63775L4.85323 5.91362C3.74609 6.84199 2.89363 8.06395 2.4155 9.45936C2.3615 9.61694 2.3615 9.78801 2.41549 9.94558C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C11.255 15.3619 12.4422 15.0737 13.4994 14.5598L15.3625 16.4229C15.6554 16.7158 16.1302 16.7158 16.4231 16.4229C16.716 16.13 16.716 15.6551 16.4231 15.3622L4.63803 3.57709ZM12.3608 13.4212L10.4475 11.5079C10.3061 11.5423 10.1584 11.5606 10.0064 11.5606H9.99151C8.96527 11.5606 8.13333 10.7286 8.13333 9.70237C8.13333 9.5461 8.15262 9.39434 8.18895 9.24933L5.91885 6.97923C5.03505 7.69015 4.34057 8.62704 3.92328 9.70247C4.86803 12.1373 7.23361 13.8619 10.0002 13.8619C10.8326 13.8619 11.6287 13.7058 12.3608 13.4212ZM16.0771 9.70249C15.7843 10.4569 15.3552 11.1432 14.8199 11.7311L15.8813 12.7925C16.6329 11.9813 17.2187 11.0143 17.5849 9.94561C17.6389 9.78803 17.6389 9.61696 17.5849 9.45938C16.5055 6.30925 13.5184 4.04303 10.0002 4.04303C9.13525 4.04303 8.30244 4.17999 7.52218 4.43338L8.75139 5.66259C9.1556 5.58413 9.57311 5.54303 10.0002 5.54303C12.7667 5.54303 15.1323 7.26768 16.0771 9.70249Z">
                </path>
              </svg>
            }
          </span>
        </div>
      </div>

      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <app-checkbox [(checked)]="isChecked" label="Mantener sesión iniciada" />
        </div>
        <a routerLink="/reset-password" class="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400">
          ¿Olvidaste tu contraseña?
        </a>
      </div>

      <app-button className="w-full" size="sm" type="submit" [disabled]="isLoading || isGoogleLoading || isMicrosoftLoading">
        @if (isLoading) {
          <span class="flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            Cargando...
          </span>
        } @else {
          Iniciar Sesión
        }
      </app-button>
    </form>

    <div class="mt-5">
      <!-- TODO: Add register link 
        <p class="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
          ¿No tienes una cuenta?
          <a
            routerLink="/signup"
            class="text-brand-500 hover:text-brand-600 dark:text-brand-400"
          >
            Registrarse
          </a>
        </p>
        -->
    </div>
    }
  </div>
</div>